// JKwan 20210721 summary of this file:
//
// The BUILD/shop page loads with step 1's city dropdown auto-selected, 
// based on URL query params if available, or pre-existing cart.attributes['city-code'] retained from the last shopping session, or 'sea'.
// Only that city's staples are then displayed, and the product grid for all other cities are hidden.
//
// Whenever the user changes step 1's city selection, the appropriate city's staples are displayed/hidden,
// and the cart.attributes are updated with this cityCode


// Essentially when the BUILD/shop page is loading...
window.addEventListener('load', (event) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const pickCity = urlParams.get('pick_city')
  
  // If a city code has been included in the URL, go with that
  if ( pickCity && 'pdx,sea,atx'.includes(pickCity) ) {
    preSelectCity(pickCity);
    return
    
  // Otherwise go with the last chosen city, fallback being 'sea'
  } else {
    const myRequest = new Request('/cart.js', { 
      method: 'GET',
      headers: {'Content-Type': 'application/json'} });

    // GET the current cart.attributes['city-code']...
    fetch(myRequest)
      .then(response => response.json())
      .then(data => {
        const existingCartCityCode = data.attributes['city-code'] || 'sea';
        preSelectCity(existingCartCityCode);
      })
      .catch(console.error);
  }
});


// Function to select and call the toggle function to display the provided city's staples
function preSelectCity(cityCode) {
  // Auto-select step 1's city with the provided cityCode...
  document.getElementById('select-city').value = cityCode;
  // And toggle the displayed/hidden staples
  toggleStaplesDisplayed(cityCode);
}

// Function to return the collection handle associated with the specified div - this handle always ends with the cityCode
function getCollectionHandle(div) {
  const regex = /\s+/;  
  const classArray = div.className.split(regex)
  const collectionHandle = classArray.filter(className => className.startsWith('staples-'))[0];
  return collectionHandle;
}

// Function to either show or hide all staples collection divs - depending if they match the provided cityCode
function toggleStaplesDisplayed(cityCode) {
  const staplesDivs = document.querySelectorAll('.staples');
  staplesDivs.forEach(div => {
    let handle = getCollectionHandle(div);
    if (handle.slice(-3) == cityCode) {
      div.style.display = 'block';
    } else {
      div.style.display = 'none';
    }
  })
  Shopify.theme.animation.init();
}

// Function to POST/update cart.attributes with the provided cityCode
function postCityToCart(cityCode) {
  try {
    const postToCartBody = { attributes: { 'city-code': cityCode } };

    const myRequest = new Request('/cart/update.js', { 
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(postToCartBody) });

    fetch(myRequest)
      .then(response => response.json())
    .then(data => {
//       console.log('Successful postCityToCart: ' + data.attributes['city-code'])
    })
    .catch(console.error);

  } catch(error) {
    console.log(error);
  }
}
